import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    id: "faq-decision",
    q: "How quickly are decisions made?",
    a: "Most applications receive a preliminary decision within a single business day. Complex or larger facilities may require additional review by our senior underwriting desk.",
  },
  {
    id: "faq-security",
    q: "What is bank-grade security?",
    a: "Every submission is transmitted over TLS 1.3 and stored using AES-256 encryption. Our platform follows SOC 2-aligned controls and undergoes independent penetration testing.",
  },
  {
    id: "faq-collateral",
    q: "Do I need to submit collateral?",
    a: "Most Lending Loan USA facilities are unsecured. Certain business and auto-financing structures may require collateral — your advisor will confirm this transparently up front.",
  },
  {
    id: "faq-credit",
    q: "Will applying affect my credit score?",
    a: "Preliminary review uses a soft inquiry that does not impact your score. A hard inquiry is only performed after you accept and sign final terms.",
  },
  {
    id: "faq-contact",
    q: "How do I contact my advisor?",
    a: "You may reach a live human concierge at +1 (202) 280-0579 during business hours, or through the secure portal delivered after approval.",
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">FAQ</div>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight sm:text-5xl">
            Answers, without the fine print theatre.
          </h2>
          <p className="mt-6 text-sm text-white/60">
            Still not sure? Speak to a human at{" "}
            <a href="tel:+12022800579" className="text-[#D4AF37] hover:text-[#F3E5AB]">
              +1 (202) 280-0579
            </a>
            .
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-b border-white/10">
                <AccordionTrigger className="py-6 text-left font-serif text-xl font-light text-white hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-white/60">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
